module.exports = __webpack_public_path__ + "generator.png?40eacd457eb0d1470ada531640214a8a";